<template>
  <div>
    <v-card outlined class="app-card">
      <v-card-title class="app-card-title">
        Autorizações
        <v-btn
          depressed
          color="primary"
          class="white--text mt-5 btn-nova"
          @click="dialog.novaAutorizacao = true"
          v-if="!isMobile"
        >
          <v-icon>add</v-icon>Autorização
        </v-btn>
      </v-card-title>
      <v-card-text class="app-card-content">
        <v-row no-gutters>
          <v-col :md="12" :sm="12" :xs="12" cols="12">
            <v-alert text outlined type="info">
              O pagamento deverá ser realizado em até 72 horas, caso contrário
              não será permitido a emissão de uma nova licença.
            </v-alert>
            <v-alert text outlined type="warning">
              Para imprimir uma Autorização de Fretamento, deverá existir pelo
              menos uma viagem cadastrada.
            </v-alert>
          </v-col>

          <v-col :md="12" :sm="12" :xs="12" cols="12" class="mt-5">
            <v-btn
              depressed
              color="primary"
              class="white--text mt-5 mb-5"
              @click="dialog.novaAutorizacao = true"
              v-if="isMobile"
            >
              <v-icon>add</v-icon>Autorização
            </v-btn>
            <v-layout v-resize="onResize" column>
              <v-data-table
                :headers="table.header"
                :items="table.content"
                :loading="table.isLoading"
                :items-per-page="5"
                item-key="name"
                :hide-default-header="isMobile"
                :class="{ mobile: isMobile }"
                :footer-props="{
                  showFirstLastPage: true
                }"
              >
                <template v-if="table.content.length" v-slot:body="{ items }">
                  <tbody>
                    <template v-for="item in items">
                      <tr v-if="!isMobile" :key="item.numeroLicenca">
                        <td>{{ item.numeroLicenca }}</td>
                        <td>{{ item.transportadora }}</td>
                        <td>{{ item.placa }}</td>
                        <td>{{ item.periodoValidade }}</td>
                        <td>{{ item.tipoLiceca }}</td>
                        <td>{{ item.situacaoDescricao }}</td>
                        <td>
                          <v-btn-toggle>
                            <v-btn
                              small
                              title="Ver Autorização"
                              color="#FFA000"
                              v-if="
                                item.situacaoId == 1 || item.situacaoId == 2
                              "
                            >
                              <router-link
                                :to="{
                                  name: 'licenca-especial-autorizacao',
                                  params: {
                                    autorizacaoId: item.id
                                  }
                                }"
                              >
                                <v-icon size="15px" class="white--text">my_location</v-icon>
                              </router-link>
                            </v-btn>
                            <v-btn
                              @click="imprmirBoleto(item.extrato)"
                              small
                              title="Imprimir Boleto"
                              color="#3eb355"
                              v-if="item.situacaoId == 1"
                            >
                              <v-icon size="15px" class="white--text">attach_money</v-icon>
                            </v-btn>
                            <v-btn
                              @click="doAutorizacaoDeleteDialog(item)"
                              small
                              title="Remover Autorização"
                              color="error"
                              v-if="item.situacaoId == 1"
                            >
                              <v-icon size="15px" class="white--text">delete</v-icon>
                            </v-btn>
                          </v-btn-toggle>
                        </td>
                      </tr>
                      <tr v-else :key="item.numeroLicenca">
                        <td class="th-mobile">
                          <ul class="flex-content">
                            <li class="flex-item">
                              <strong>Nº Licença</strong>
                              <span>{{ item.numeroLicenca }}</span>
                            </li>
                            <li class="flex-item">
                              <strong>Transportadora</strong>
                              <span>{{ item.transportadora }}</span>
                            </li>
                            <li class="flex-item">
                              <strong>Placa</strong>
                              <span>{{ item.placa }}</span>
                            </li>
                            <li class="flex-item">
                              <strong>Validade</strong>
                              <span>{{ item.periodoValidade }}</span>
                            </li>
                            <li class="flex-item">
                              <strong>Licença</strong>
                              <span>{{ item.tipoLiceca }}</span>
                            </li>
                            <li class="flex-item">
                              <strong>Tipo Licença</strong>
                              <span>{{ item.tipoLiceca }}</span>
                            </li>
                            <li class="flex-item">
                              <strong>Situação</strong>
                              <span>{{ item.situacaoDescricao }}</span>
                            </li>

                            <li class="flex-item">
                              <strong>Ações</strong>
                              <v-btn-toggle>
                                <v-btn
                                  small
                                  title="Ver Autorização"
                                  color="#FFA000"
                                  v-if="
                                    item.situacaoId == 1 || item.situacaoId == 2
                                  "
                                >
                                  <router-link
                                    :to="{
                                      name: 'licenca-especial-autorizacao',
                                      params: {
                                        autorizacaoId: item.id
                                      }
                                    }"
                                  >
                                    <v-icon size="15px" class="white--text">my_location</v-icon>
                                  </router-link>
                                </v-btn>
                                <v-btn
                                  @click="imprmirBoleto(item.extrato)"
                                  small
                                  title="Imprimir Boleto"
                                  color="#3eb355"
                                  v-if="item.situacaoId == 1"
                                >
                                  <v-icon size="15px" class="white--text">attach_money</v-icon>
                                </v-btn>
                                <v-btn
                                  @click="doAutorizacaoDeleteDialog(item)"
                                  small
                                  title="Remover Autorização"
                                  color="error"
                                  v-if="item.situacaoId == 1"
                                >
                                  <v-icon size="15px" class="white--text">delete</v-icon>
                                </v-btn>
                              </v-btn-toggle>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>

                <template v-if="!table.content.length && table.isLoading" v-slot:progress>
                  <v-progress-linear indeterminate></v-progress-linear>
                </template>

                <template v-if="!table.content.length" v-slot:no-data>Não a itens disponíveis</template>
              </v-data-table>
            </v-layout>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog.novaAutorizacao" persistent width="600">
      <AutorizacaoForm
        v-if="dialog.novaAutorizacao"
        :veiculoTransportadoraId="veiculoTransportadoraId"
        @closeDialog="closeDialog"
      />
    </v-dialog>

    <v-dialog v-model="dialog.deleteAutorizacao" persistent width="400">
      <AutorizacaoDeleteDialog
        v-if="dialog.deleteAutorizacao"
        :autorizacao="autorizacaoSelect"
        @closeDialog="closeDialog"
      />
    </v-dialog>
  </div>
</template>

<script>
import LicencaEspecialService from '@/services/licencaEspecial.service'
import GlobalStore from '@/store/modules/global'

import AutorizacaoForm from './AutorizacaoForm'
import AutorizacaoDeleteDialog from './AutorizacaoDeleteDialog'

import { VUE_APP_SIT_API_URL, VUE_APP_PDF_URL, VUE_APP_FINANCEIRO_API_URL } from '@/commons/config'

export default {
  name: 'AutorizacaoList',
  props: { veiculoTransportadoraId: Number },
  components: {
    AutorizacaoForm,
    AutorizacaoDeleteDialog
  },
  data() {
    return {
      isMobile: false,
      table: {
        header: [
          { text: 'Nº Licença' },
          { text: 'Transportadora' },
          { text: 'Placa' },
          { text: 'Período de Validade' },
          { text: 'Tipo de Licença' },
          { text: 'Situação' },
          { text: 'Ações' }
        ],
        content: [],
        isLoading: false
      },
      dialog: {
        novaAutorizacao: false,
        deleteAutorizacao: false
      },
      autorizacaoSelect: null
    }
  },
  methods: {
    loadAutorizacoes() {
      this.table.content = []
      this.table.isLoading = true
      LicencaEspecialService.listarTodasAutorizacoesFretamento(
        this.veiculoTransportadoraId
      ).subscribe(
        (res) => {
          this.table.content = res.sort((a, b) =>
            a.situacaoId > b.situacaoId ? 1 : -1
          )
          this.table.isLoading = false
        },
        (error) => {
          this.table.isLoading = false
        }
      )
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true
      else this.isMobile = false
    },
    closeDialog(event) {
      if (event.type === 'success') {
        GlobalStore.setSnackBar({
          show: true,
          message: event.message,
          type: event.type
        })
        this.loadAutorizacoes()
      }
      this.dialog.novaAutorizacao = false
      this.dialog.deleteAutorizacao = false
    },
    doAutorizacaoDeleteDialog(autorizacao) {
      this.autorizacaoSelect = autorizacao
      this.dialog.deleteAutorizacao = true
    },
    imprmirBoleto(extrato) {
      window.open(`${VUE_APP_FINANCEIRO_API_URL}/api/pdf/detran/dae/${extrato}`, '_blank')
    }
  },
  mounted() {
    this.loadAutorizacoes()
  }
}
</script>

<style lang="scss" scoped>
.btn-nova {
  position: absolute;
  right: 17px;
  top: -12px;
}
.btn-voltar {
  position: absolute;
  right: 20px;
}
</style>
